/** @format */

import { Component, Input } from '@angular/core';

import { Scene7Service, TaggingService } from '@shared/utils/services';

@Component({
    selector: 'shared-media-component-scene7',
    templateUrl: './media-scene7.component.html',
    standalone: false
})
export class MediaScene7Component {
	@Input() altText: string;
	@Input() image: string;
	@Input() mobileImg: string;
	@Input() gif: string;
	@Input() gifMobile: string;
	@Input() itemTitle: string;
	@Input() imagePreset: any;
	@Input() willLazyLoad = true;

	public altTagService: any;

	constructor(
		private taggingService: TaggingService,
		private scene7Service: Scene7Service
	) {
		this.altTagService = this.taggingService.altTag;
	}

	public scene7service(imageName, imagePreset, isContent) {
		return this.scene7Service.scene7Url(imageName, imagePreset, isContent);
	}
}
